import { Button } from "@public/ui-toolkit";
import React, { useState } from "react";
import WeekTab from "./WeekTab";

const weekData = [
  {
    id: "monday-tab",
    day: "Monday",
    dataBsTarget: "#monday",
    ariaControls: "monday",
    type: "primary",
  },
  {
    id: "tuesday-tab",
    day: "Tuesday",
    dataBsTarget: "#tuesday",
    ariaControls: "tuesday",
  },
  {
    id: "wednesday-tab",
    day: "Wednesday",
    dataBsTarget: "#wednesday",
    ariaControls: "wednesday",
  },
  {
    id: "thursday-tab",
    day: "Thursday",
    dataBsTarget: "#thursday",
    ariaControls: "thursday",
  },
  {
    id: "friday-tab",
    day: "Friday",
    dataBsTarget: "#friday",
    ariaControls: "friday",
  },
  {
    id: "saturday-tab",
    day: "Saturday",
    dataBsTarget: "#saturday",
    ariaControls: "saturday",
  },
  {
    id: "sunday-tab",
    day: "Sunday",
    dataBsTarget: "#sunday",
    ariaControls: "sunday",
  },
];

const ManageScheduling = ({ schedule, loading, updateSchedule }) => {
  const [updatedSchedule, setUpdatedSchedule] = useState([]);
  const [selectedTab, setSelectedTab] = useState("Monday");

  const onSubmit = () => updateSchedule(updatedSchedule);
  return (
    <main>
      <div className="main-inner">
        <div className="container">
          <div
            className="
            manage-schedule
            rounded-large
            box-shadow
            bg-white
            p-xxl-5 p-md-4 p-1
            py-3
            mb-sm-5 mb-4
            mt-4
          "
          >
            <div className="text-center mb-5">
              <h2 className="stylish-title text-blue">Manage Schedule</h2>
            </div>
            <div className="for-tabs">
              <div className="hf-horizontal-tabs row gx-xl-5 gy-4">
                <div className="hf-horizontal-tabs-navBox col-lg-3 col-xl-4">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {weekData.map((days) => {
                      return (
                        <li
                          className="nav-item"
                          role="presentation"
                          key={days.id}
                        >
                          <button
                            className={
                              days.type === "primary"
                                ? "nav-link active"
                                : "nav-link"
                            }
                            onClick={() => setSelectedTab(days.day)}
                            id={days.id}
                            data-bs-toggle="tab"
                            data-bs-target={days.dataBsTarget}
                            type="button"
                            role="tab"
                            aria-controls={days.ariaControls}
                            aria-selected="false"
                          >
                            {days.day}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="hf-horizontal-tabs-contentBox col-lg-9 col-xl-8">
                  <div
                    className="
                    tab-content
                    rounded-large
                    bg-lightgrey2
                    p-md-4 p-3
                    h-100
                  "
                    id="myTabContent"
                  >
                    <div>
                      <h2>Time Slot Availability</h2>
                      {/* <p>Add some description, what is happing.</p> */}
                      {[
                        "monday",
                        "tuesday",
                        "wednesday",
                        "thursday",
                        "friday",
                        "saturday",
                        "sunday",
                      ].map((name, index) => {
                        return (
                          <WeekTab
                            key={index}
                            selectedTab={selectedTab}
                            updatedSchedule={updatedSchedule}
                            setUpdatedSchedule={(update) =>
                              setUpdatedSchedule([...update])
                            }
                            schedule={schedule}
                            day={index}
                            id={name}
                            ariaLabelLedBy={`${name}-tab`}
                            loading={loading}
                          />
                        );
                      })}
                      <div className="text-center mt-5 pt-lg-5">
                        <Button
                          loading={loading}
                          disabled={updatedSchedule.length === 0}
                          btnName="Save"
                          btnType="primary"
                          onClick={() => onSubmit()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ManageScheduling;
